export default {"src":"/_next/static/media/Oval (2).bffcbda5.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};